import React from "react";
import { PageContainer, PageHeader } from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { CustomerClassTab } from "@/components/fiscal/CustomerClassTab";
import { AuthorizedRncTab } from "@/components/fiscal/AuthorizedRncTab";
import { RiskTab, EventsTab } from "@/components/fiscal/RiskTabs";

export default function Fiscal() {
  return (
    <PageContainer>
      <PageHeader title="Control fiscal" subtitle="Clasificación de clientes, autorización E44, ventas exentas en riesgo y auditoría de errores de emisión." testid="fiscal-header" />
      <Tabs defaultValue="clientes">
        <TabsList>
          <TabsTrigger value="clientes" data-testid="fiscal-tab-clientes">Clasificación de clientes</TabsTrigger>
          <TabsTrigger value="rnc" data-testid="fiscal-tab-rnc">RNC autorizados E44</TabsTrigger>
          <TabsTrigger value="riesgo" data-testid="fiscal-tab-riesgo">Ventas exentas en riesgo</TabsTrigger>
          <TabsTrigger value="eventos" data-testid="fiscal-tab-eventos">Errores de emisión</TabsTrigger>
        </TabsList>
        <TabsContent value="clientes"><CustomerClassTab /></TabsContent>
        <TabsContent value="rnc"><AuthorizedRncTab /></TabsContent>
        <TabsContent value="riesgo"><RiskTab /></TabsContent>
        <TabsContent value="eventos"><EventsTab /></TabsContent>
      </Tabs>
    </PageContainer>
  );
}
